import { Component, Input } from '@angular/core';
@Component({
  selector: 'core-form-hint',
  templateUrl: './core-form-hint.component.html',
  styleUrls: ['./core-form-hint.component.scss']
})
export class CoreFormHintComponent {
  @Input() hint = 'Enter a hint';
}
